export default __webpack_public_path__ + "static/media/11.bd8823bf.jpg";